import * as constants from './scenes.constants'
import Model from './scenes.model'

export default function scenes (state = Model, action) {
  switch (action.type) {
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/scenes/scenes.reducer.js